import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "half-sibling-container",
  id: "half-sibling-container-1"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "half-sibling-connector",
  id: "half-sibling-connector-1"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "vertical-connector" }, null, -1)
const _hoisted_4 = {
  key: 1,
  class: "half-sibling-container",
  id: "half-sibling-container-2"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "half-sibling-connector",
  id: "half-sibling-connector-2"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "vertical-connector" }, null, -1)

import { onMounted, onUpdated, ref } from "vue";
import TreeUtils from "@/bll/tree_utils.mjs";
import FamilyMember from "@/bll/models/FamilyMember.mjs";
import GenerationComponent from "./GenerationComponent.vue";
import Gender from "@/bll/models/Gender.mjs";
import BllUtils from "@/bll/utils.mjs";

interface Props {
  self: FamilyMember;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ParentComponent',
  props: {
    self: {}
  },
  setup(__props: any) {

const props = __props;

const container = ref();

var parents: FamilyMember[] | undefined;



function getParents(): FamilyMember[] {
  if (!parents) {
    parents = TreeUtils.getAncestors(props.self);
  }
  return parents;
}

function getHalfSiblings(parent: FamilyMember): FamilyMember[] {
  const siblings = [...props.self._brothers, ...props.self._sisters];
  return parent.gender == Gender.MALE
    ? BllUtils.filterPaternalHalfSiblings(props.self, siblings)
    : BllUtils.filterMaternalHalfSiblings(props.self, siblings);
}

function configureHalfSibling(treeContainer: Element, parentNumber: number) {
  const halfSiblingContainer = container.value.querySelector(
    ":scope #half-sibling-container-" + parentNumber
  );

  if (!halfSiblingContainer) return;

  const verticalBar = halfSiblingContainer.querySelector(
    ":scope .vertical-connector"
  );

  verticalBar.style.height = "65px";
  const halfSiblingsBuffer = 150;

  const sharedParentRect = container.value
    .querySelectorAll(
      ":scope > .generation-container > li > .member-node-container > .node-container"
    )
    [parentNumber - 1].getBoundingClientRect();

  if (parentNumber == 1) {
    const fullSiblingContainer = treeContainer.querySelector(
      ":scope #full-siblings-container"
    );

    const fullSiblingContainerWidth =
      fullSiblingContainer?.getBoundingClientRect().width
        ? fullSiblingContainer?.getBoundingClientRect().width +
          halfSiblingsBuffer
        : 0;

    container.value.style.setProperty(
      "--half-sibling-container-right-" + parentNumber,
      halfSiblingsBuffer +
        fullSiblingContainerWidth +
        treeContainer.getBoundingClientRect().width +
        "px"
    );

    container.value.style.setProperty(
      "--half-sibling-connector-width-" + parentNumber,
      sharedParentRect.left - verticalBar.getBoundingClientRect().right + "px"
    );

    container.value.style.setProperty(
      "--half-sibling-connector-right-" + parentNumber,
      verticalBar.getBoundingClientRect().left -
        halfSiblingContainer.getBoundingClientRect().left +
        "px"
    );
  } else if (parentNumber == 2) {
    container.value.style.setProperty(
      "--half-sibling-container-left-" + parentNumber,
      halfSiblingsBuffer + treeContainer.getBoundingClientRect().width + "px"
    );

    container.value.style.setProperty(
      "--half-sibling-connector-width-" + parentNumber,
      verticalBar.getBoundingClientRect().left - sharedParentRect.right + "px"
    );

    container.value.style.setProperty(
      "--half-sibling-connector-left-" + parentNumber,
      sharedParentRect.right -
        halfSiblingContainer.getBoundingClientRect().left +
        "px"
    );
  }
}

onMounted(() => {
  configureComponent();
});

onUpdated(() => {
  configureComponent();
});

function configureComponent() {
  const treeContainer = document.querySelector(".tree-container");
  setTimeout(() => {
    configureHalfSibling(treeContainer!, 1);
    configureHalfSibling(treeContainer!, 2);
  }, 0);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "parent-component-container",
    ref_key: "container",
    ref: container
  }, [
    _createVNode(GenerationComponent, {
      "family-members": getParents(),
      "is-ascending": true,
      "is-descention-allowed": false
    }, null, 8, ["family-members"]),
    (getHalfSiblings(getParents()[0]).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createVNode(GenerationComponent, {
            "family-members": getHalfSiblings(getParents()[0]),
            "is-ascending": false,
            "is-ascention-allowed": false,
            "is-descention-allowed": true
          }, null, 8, ["family-members"])
        ]))
      : _createCommentVNode("", true),
    (
        getParents().length == 2 && getHalfSiblings(getParents()[1]).length > 0
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createVNode(GenerationComponent, {
            "family-members": getHalfSiblings(getParents()[1]),
            "is-ascending": false,
            "is-ascention-allowed": false,
            "is-descention-allowed": true
          }, null, 8, ["family-members"])
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})